import React from 'react';

// Small consumer-facing payment icons row shown directly under the CTA.
// (Different from the Stripe-trust block used at the bottom of the page.)
const PayLogo = ({ children, bg = '#FFFFFF', color = '#1a1a1a', border = '#e5e5e5' }) => (
  <div
    className="h-7 px-2 flex items-center justify-center"
    style={{ backgroundColor: bg, color, border: `1px solid ${border}`, borderRadius: '6px', minWidth: '42px' }}
  >
    {children}
  </div>
);

const PaymentIconsInline = () => (
  <div className="flex flex-wrap items-center justify-center gap-1.5">
    {/* VISA */}
    <PayLogo bg="#1A1F71" color="#FFFFFF" border="#1A1F71">
      <span style={{ fontFamily: 'Arial, sans-serif', fontWeight: 900, fontStyle: 'italic', fontSize: '11px', letterSpacing: '0.5px' }}>
        VISA
      </span>
    </PayLogo>
    {/* MASTERCARD */}
    <PayLogo>
      <div className="relative w-7 h-4">
        <span className="absolute left-0 top-0 w-4 h-4 rounded-full" style={{ backgroundColor: '#EB001B' }} />
        <span className="absolute right-0 top-0 w-4 h-4 rounded-full" style={{ backgroundColor: '#F79E1B', mixBlendMode: 'multiply' }} />
      </div>
    </PayLogo>
    {/* AMEX */}
    <PayLogo bg="#2671B9" color="#FFFFFF" border="#2671B9">
      <span style={{ fontFamily: 'Arial, sans-serif', fontWeight: 900, fontSize: '9px', letterSpacing: '0.4px' }}>
        AMEX
      </span>
    </PayLogo>
    {/* APPLE PAY */}
    <PayLogo bg="#000000" color="#FFFFFF" border="#000000">
      <svg viewBox="0 0 24 10" width="34" height="14" fill="#FFFFFF">
        <path d="M4.1 1.4c.2-.3.3-.7.3-1.1-.3 0-.7.2-.9.5-.2.2-.4.6-.3 1 .3 0 .7-.2.9-.4zM4.4 1.9c-.5 0-1 .3-1.2.3-.3 0-.7-.3-1.1-.3-.6 0-1.1.3-1.4.9-.6 1-.2 2.5.4 3.4.3.4.7.9 1.2.9.5 0 .7-.3 1.3-.3s.7.3 1.2.3c.5 0 .9-.4 1.2-.9.4-.5.5-1 .5-1s-1-.4-1-1.4c0-.8.6-1.2.6-1.2-.3-.5-.9-.6-1.1-.6zM10.7 1.1H8.8v6.3h1V5.2h1.3c1.2 0 2-.8 2-2.1s-.8-2-2.4-2zm-.2 3.3h-.7V2h.7c.8 0 1.3.4 1.3 1.2 0 .8-.5 1.2-1.3 1.2zM15.6 3.2c-1.1 0-1.8.6-1.9 1.4h.9c.1-.4.4-.6 1-.6.6 0 .9.3.9.8v.4l-1.3.1c-1.2.1-1.8.6-1.8 1.4 0 .8.6 1.4 1.5 1.4.6 0 1.2-.3 1.5-.8h.1v.7h.9V5c0-1.1-.9-1.8-1.8-1.8zm.9 2.7c0 .6-.5 1.1-1.1 1.1-.5 0-.8-.2-.8-.6 0-.4.3-.6.9-.7l1-.1v.3zM19.1 9c1 0 1.4-.4 1.8-1.5l1.7-4.4h-1l-1.1 3.6h-.1L19.3 3h-1l1.6 4.4-.1.3c-.1.4-.3.6-.7.6h-.3v.7c.1 0 .2.1.3 0z"/>
      </svg>
    </PayLogo>
    {/* GOOGLE PAY */}
    <PayLogo>
      <span style={{ fontFamily: 'Arial, sans-serif', fontSize: '10px', fontWeight: 500 }}>
        <span style={{ color: '#5F6368' }}>G</span>
        <span style={{ color: '#5F6368' }}> Pay</span>
      </span>
    </PayLogo>
    {/* PAYPAL */}
    <PayLogo>
      <span style={{ fontFamily: 'Arial, sans-serif', fontSize: '10px', fontWeight: 800 }}>
        <span style={{ color: '#003087' }}>Pay</span>
        <span style={{ color: '#009CDE' }}>Pal</span>
      </span>
    </PayLogo>
    {/* SHOP PAY */}
    <PayLogo bg="#5A31F4" color="#FFFFFF" border="#5A31F4">
      <span style={{ fontFamily: 'Arial, sans-serif', fontSize: '9px', fontWeight: 800, letterSpacing: '0.3px' }}>
        SHOP PAY
      </span>
    </PayLogo>
  </div>
);

export default PaymentIconsInline;
